import { Button, Box, Typography } from '@mui/material';
import { useAuth } from 'oidc-react';
import { PWColors } from '../../../Theme/PWColors';

const useStyles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    left: 0,
    right: 0,
    height: '48px',
    backgroundColor: PWColors.dark.primary[800],
    padding: '2px 0',
    zIndex: 1000
  },
  spacer: {
    height: '48px'
  }
});

export default function ImpersonationBanner() {
  const styles = useStyles();
  const { userData, userManager } = useAuth();
  var impersonatedBy = userData?.profile.act || '';

  const handleEndImpersonation = () => {
    userManager.removeUser();
    try {
      const actData = JSON.parse(userData?.profile.act || '{"referringUrl":""}');
      let referringUrl = actData.referringUrl || '';
      if (referringUrl && !referringUrl.startsWith('http://') && !referringUrl.startsWith('https://')) {
        referringUrl = `https://${referringUrl}`;
      }
      const userId = userData?.profile.sub || '';
      window.location.href = `${referringUrl}/User/Details/${userId}` || '/';
    } catch (error) {
      window.location.href = '/';
    }
  };

  if (impersonatedBy) {
    return (
        <>
            <Box sx={styles.container}>
                <Typography variant='body1'>Impersonating: <b>{userData?.profile.name}</b></Typography>
                <Button onClick={handleEndImpersonation}>End Impersonation</Button>
            </Box>
            <Box sx={styles.spacer} />
        </>
    );
  }

  return null;
}
